import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const fetchWholesalersByState = async (state) => {
  const res = await axios.get(`${API_BASE}/wholesalers/${encodeURIComponent(state)}`);
  return res.data;
};

export const submitRegistration = async (formData) => {
  const res = await axios.post(`${API_BASE}/register`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};
